<template>
  <div class="system-dic-dialog-container">
    <el-dialog :title="title" :visible.sync="isShowDialog" width="1150px">
      <el-form
        ref="dicDialogFormRef"
        :model="formData"
        v-loading="isLoading"
        :rules="rules"
        size="small"
        label-width="90px"
        class="demo-ruleForm"
      >
        <el-row :gutter="35">
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="mb20">
            <el-form-item label="姓名">
              <el-input
                v-model="formData.Name"
                placeholder="请输入"
                disabled
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="mb20">
            <el-form-item label="性别">
              <el-input
                v-model="formData.Gender"
                placeholder="请输入"
                disabled
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="mb20">
            <el-form-item label="电话">
              <el-input
                v-model="formData.Phone"
                placeholder="请输入"
                disabled
                clearable
              ></el-input>
            </el-form-item>
          </el-col> -->
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="mb20">
            <el-form-item label="身份证号">
              <el-input
                v-model="formData.IDCard"
                placeholder="请输入"
                disabled
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col
            v-for="(item, index) in formData.DetailsDtos"
            :key="index"
            :xs="24"
            :sm="12"
            :md="12"
            :lg="12"
            :xl="12"
            class="mb20"
          >
            <el-form-item :label="item.TalentName" prop="EndTime">
              <el-input
                v-if="item.Type == 1"
                v-model="item.Text"
                disabled
                clearable
              ></el-input>
              <el-input
                v-else
                v-model="item.TalentValue"
                disabled
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col
            :xs="24"
            :sm="24"
            :md="24"
            :lg="24"
            :xl="24"
            class="mb20"
            v-if="formData.FileName"
          >
            <el-form-item label="申请材料" prop="EndTime">
              <div style="display: flex">
                <div style="color: #409eff; margin-right: 40px">
                  {{ formData.FileName }}
                </div>
                <el-button size="small" type="primary" @click="gotoPreview"
                  >预览申请材料</el-button
                >
              </div>
            </el-form-item>
          </el-col>
          <!-- <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="mb20">
            <el-form-item label="身份证正面" prop="bRemark">
              <el-image
                :src="formData.FrontPhoto"
                :preview-src-list="[formData.FrontPhoto]"
                class="idcard"
                fit="contain"
              >
                <div slot="placeholder" class="image-slot">
                  加载中<span class="dot">...</span>
                </div>
              </el-image>
            </el-form-item>
          </el-col> -->
          <!-- <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="mb20">
            <el-form-item label="身份证背面" prop="bRemark">
              <el-image
                :src="formData.BackPhoto"
                :preview-src-list="[formData.BackPhoto]"
                class="idcard"
                fit="cover"
              >
                <div slot="placeholder" class="image-slot">
                  加载中<span class="dot">...</span>
                </div>
              </el-image>
            </el-form-item>
          </el-col> -->
          <!-- <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="mb20">
            <el-form-item label="学历证书" prop="EndTime">
              <el-image
                :src="formData.EducationCertificate"
                :preview-src-list="[formData.EducationCertificate]"
                class="idcard"
                fit="cover"
              >
                <div slot="placeholder" class="image-slot">
                  加载中<span class="dot">...</span>
                </div>
              </el-image>
            </el-form-item>
          </el-col> -->
          <!-- <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="mb20">
            <el-form-item label="学位证书" prop="EndTime">
              <el-image
                :src="formData.DegreeCertitfic"
                :preview-src-list="[formData.DegreeCertitfic]"
                class="idcard"
                fit="cover"
              >
                <div slot="placeholder" class="image-slot">
                  加载中<span class="dot">...</span>
                </div>
              </el-image>
            </el-form-item>
          </el-col> -->
          <!-- <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="mb20">
            <el-form-item label="免冠照" prop="EndTime">
              <el-image
                :src="formData.PassportPhtot"
                :preview-src-list="[formData.PassportPhtot]"
                class="idcard"
                fit="cover"
              >
                <div slot="placeholder" class="image-slot">
                  加载中<span class="dot">...</span>
                </div>
              </el-image>
            </el-form-item>
          </el-col> -->
          <!-- <el-col
            :xs="24"
            :sm="24"
            :md="24"
            :lg="24"
            :xl="24"
            class="mb20"
            v-if="formData.OtherMaterial"
          >
            <el-form-item label="其他照片" prop="EndTime">
              <el-image
                v-for="(item, index) in getUrlList(formData.OtherMaterial)"
                :key="index"
                :src="item"
                :preview-src-list="[item]"
                class="idcard"
                fit="cover"
              >
                <div slot="placeholder" class="image-slot">
                  加载中<span class="dot">...</span>
                </div>
              </el-image>
            </el-form-item>
          </el-col> -->
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="审核备注" prop="HandlInstruction">
              <el-input
                v-model="formData.HandlInstruction"
                placeholder="请输入备注"
                type="textarea"
                rows="3"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <template #footer>
        <span class="dialog-footer" v-loading="isLoading">
          <el-button
            v-if="DeclareResult === 0"
            :loading="btnLoading"
            type="danger"
            @click="onSubmit(1)"
            size="default"
            >审核拒绝</el-button
          >
          <el-button
            :loading="btnLoading"
            v-if="DeclareResult === 0"
            type="success"
            @click="onSubmit(2)"
            size="default"
            >审核通过</el-button
          >
          <el-button @click="onCancel" size="default">取 消</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import {
  GetIntegraltalentDetails,
  PutApartmentApprovlState,
} from "@/api/talentApartmet/index";
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";

export default {
  components: { Editor, Toolbar },
  props: {
    DeclareResult: Number,
  },
  data() {
    return {
      editor: null,
      key: "edit",
      title: "编辑",
      isShowDialog: false,
      isLoading: false,
      btnLoading: false,
      formData: {},
      rules: {},
    };
  },
  computed: {
    getUrlList() {
      return function (urls) {
        if (!urls) return [];
        return urls.split(",");
      };
    },
  },
  methods: {
    gotoPreview() {
      let routeUrl = this.$router.resolve({
        path: "/preview",
        // query: { url: this.formData.FromData },
        query: { url: this.formData.FromData },
      });
      window.open(routeUrl.href, "_blank");
    },
    openDialog(e, key) {
      this.formData = {};
      this.key = key;
      this.resetForm("");
      let dic = {
        edit: "编辑",
        add: "新增",
        preview: "预览",
      };
      this.title = dic[key];
      key == "preview" &&
        this.HttpGetIntegraltalentDetails({ Approvleid: e.Id });

      this.isShowDialog = true;
    },
    resetForm(formName) {
      this.$refs.dicDialogFormRef && this.$refs.dicDialogFormRef.resetFields();
    },
    onCancel() {
      this.isShowDialog = false;
    },
    handleAvatarSuccess(res, file) {
      this.formData.Picture = res.response.Url;
    },
    beforeAvatarUpload(file) {
      const isImage = file.type.includes("image");
      const isLt4M = file.size / 1024 / 1024 < 10;
      if (!isImage) {
        this.$message.error("上传头像图片只能是图片格式!");
      }
      // if (!isLt4M) {
      //   this.$message.error("上传图片大小不能超过 10MB!");
      // }
      // return isImage && isLt4M;
      return isImage;
    },
    onSubmit(Declareresultstate) {
      this.btnLoading = true;
      let that = this;
      this.$refs.dicDialogFormRef.validate((valid) => {
        this.btnLoading = false;
        if (valid) {
          that.submit(Declareresultstate);
        } else {
          console.log("error submit!!", valid);
          return false;
        }
      });
    },
    submit(Declareresultstate) {
      let param = {
        Declareresultstate,
        ApartmentApprovlId: this.formData.Approvleid,
        HandlInstruction: this.formData.HandlInstruction,
      };
      let that = this;
      let dic = {
        //申办结果1:未通过，2:已通过
        1: "是否拒绝该申请？",
        2: "是否通过该申请？",
      };
      this.$confirm(`${dic[Declareresultstate]}`, "提示", {}).then(() => {
        that.key == "preview" && that.HttpUpdateBlogDetail(param);
      });
    },
    onCreated(editor) {
      this.editor = Object.seal(editor); // 【注意】一定要用 Object.seal() 否则会报错
    },
    async HttpGetIntegraltalentDetails(param) {
      this.isLoading = true;
      const response = await GetIntegraltalentDetails(param);
      this.isLoading = false;
      let res = response.data;
      if (res.status == 200) {
        let raw = res.response || {};
        if (!raw.TalentDetailsDtos) raw.TalentDetailsDtos = [];
        this.formData = raw;
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
      }
    },
    async HttpUpdateBlogDetail(param) {
      this.btnLoading = true;
      const response = await PutApartmentApprovlState(param);
      this.btnLoading = false;
      let res = response.data;
      if (res.status == 200) {
        this.isShowDialog = false;
        this.$emit("refresh");
        this.$message({
          message: "操作成功",
          type: "success",
        });
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
      }
    },
    async HttpAddBlogDetail(param) {
      this.btnLoading = true;
      const response = await AddBlogDetail(param);
      this.btnLoading = false;
      let res = response.data;
      if (res.status == 200) {
        this.isShowDialog = false;
        this.$emit("refresh");
        this.$message({
          message: "操作成功",
          type: "success",
        });
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
      }
    },
  },
};
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>
<style>
.center {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.idcard {
  width: 258px;
  height: 162px;
  border: 1px solid #e4e7ed;
  background: #f4f5f7;
  border-radius: 4px;
}
</style>
